<ng-container *ngIf="!verifyMobileNumber; else verifyMobileNumberTemplate">
  <h2>Your mobile number</h2>

  <div class="container">
    <div class="hint">Please provide your mobile number for security purposes</div>

    <form [formGroup]="form">
      <div>
        <div style="display: flex">
          <hfc-phone-prefix-dropdown formControlName="prefix"></hfc-phone-prefix-dropdown>
          <hfc-text-input
            type="tel"
            mask="0*"
            style="margin-left: 12px; flex: 1"
            formControlName="number"
            hfcRemoveLeadingZero="prefix"
          ></hfc-text-input>
        </div>
      </div>
    </form>

    <ng-container *ngIf="numberControl.invalid && (numberControl.touched || numberControl.dirty)">
      <div *ngIf="numberControl.errors?.required" class="text-red validation-error">Mobile number is required.</div>
      <div *ngIf="numberControl.errors?.ukPhoneValidator" class="text-red validation-error">
        Please enter a valid mobile number.
      </div>
    </ng-container>

    <div class="buttons">
      <hfc-button type="primary" [isLoading]="isSubmitting" [disabled]="isSubmitting" (click)="onNextClicked()"
        >Save and Next
      </hfc-button>
    </div>
  </div>
</ng-container>
<ng-template #verifyMobileNumberTemplate>
  <div class="container" [class.isSubmitting]="isSubmitting">
    <div class="heading">
      <i class="material-icons" (click)="verifyMobileNumber = !verifyMobileNumber">arrow_back</i>
      <h2>Verify your number</h2>
    </div>

    <p class="hint">Please enter the 6 digit code we have sent to {{ mobile }}. This will expire in 10 minutes.</p>

    <form>
      <hfc-code-input
        [invalid]="isInputRed"
        [disabled]="isSubmitting"
        (codeEnter)="onCodeEntered($event)"
      ></hfc-code-input>
    </form>
  </div>

  <hfc-spinner *ngIf="isSubmitting"></hfc-spinner>

  <ng-container *ngIf="!isSubmitting">
    <p class="hint" [class.red]="isRequestNewCodeRed">
      <ng-container *ngIf="!canRequestNewCode; else canRequestTpl">
        Didn’t get a code? You can request a new one in {{ remainingSeconds }}s.
      </ng-container>

      <ng-template #canRequestTpl>
        <div>
          <span
            (click)="onRequestNewClicked()"
            class="link-button"
            [class.loading]="isRequestNewCodeLoading"
            *ngIf="!isRequestNewCodeLoading"
            >Request new code</span
          >
        </div>
      </ng-template>
    </p>

    <p *ngIf="requestMessage" [class.red]="isRequestNewCodeRed">{{ requestMessage }}</p>
  </ng-container>
</ng-template>
